// src/app/translations.ts

import { copy } from "ionicons/icons";

// Add an index signature to the type definition of TRANSLATIONS
declare interface Translations {
  [key: string]: { [key: string]: string };
}

export const translations : Translations = {
    en: {
      rep_report: 'Report',  
      procedures: 'Procedures',
      header_all_locations: 'All Locations',
      header_all_devices: 'All Devices',
      mnu_settings: 'Settings',
      mnu_download_pdf: 'Download PDF',
      mnu_report_preview: 'Preview',
      mnu_inapoi: 'Back',
      tab_locationName: 'Location',
      tab_date: 'Date/Time',
      mnu_report: 'Report',
      card_total_vol: 'Total Volume',
      card_this_month: 'Current Month Volume',
      card_last_month: 'Previous Month Volume',
      card_two_months_ago: 'Previous 2 Months Volume',
      mnu_locatii: 'Locations',
      mnu_setari: 'Settings',
      mnu_logout: 'Logout',
      select_page_of_users: 'Select Number of Rows',
      no_data_matching_the_filter: 'No Matching Data',
      choose_language: 'Select Language',
      copy_right: '©Copyright',
      login_title: 'Account Login',
      tab_val_yes: 'Yes',
      tab_val_no: 'No',
      filter_valoare_noua: 'New Value…',
      filter_click_for_filter: 'Enter Filter Value and Press Enter',
      tab_wasSuccesfull: 'Success',
      tab_mId: 'Nebulizer ID',
      tab_tempEnd: 'Final Temperature',
      tab_machineTotalVolume: 'Cumulated Nebulizer Volume',
      tab_pm03End: 'PM 0.3 Final',
      tab_runVolume: 'Procedure Volume',
      tab_machineSerialNumber: 'Nebulizer Serial Number',
      tab_hasSensors: 'Has Sensors',
      tab_userDetailsUserName: 'User Name',
      tab_pm10End: 'PM 10 Final',
      tab_tempStart: 'Initial Temperature',
      tab_userDetailsUserArea: 'User Area',
      tab_tvocEnd: 'TVOC Final',
      tab_pm10Start: 'PM 10 Initial',
      tab_dewPoinStart: 'Initial Dew Point',
      tab_substanceIdx: 'Solution Indicator',
      tab_mTime: 'Nebulizer Time',
      tab_machineOwnerName: 'Nebulizer Owner',
      tab_roomNumber: 'Room Number',
      tab_solutionName: 'Solution Name',
      tab_roomDetailsRoomName: 'Room Name',
      tab_tvocStart: 'TVOC Initial',
      tab_pm25Start: 'PM 2.5 Initial',
      tab_roomName: 'Room Name',
      tab_roomDetailsRoomArea: 'Room Area',
      tab_pm25End: 'PM 2.5 Final',
      tab_humidEnd: 'Final Humidity',
      tab_startTime: 'Start Time',
      tab_userDetailsUserAuthTime: 'User Authorization Time',
      tab_endTime: 'End Time',
      tab_humidStart: 'Initial Humidity',
      tab_pm03Start: 'PM 0.3 Initial',
      tab_dewPoinEnd: 'Final Dew Point',
      // tab_wasSuccesful: 'Was Successful',/
      tab_co2Start: 'Initial CO2',
      tab_roomDetailsRoomVolume: 'Room Volume',
      tab_co2End: 'Final CO2'
    },
    ro: {  
      rep_report: 'Raport',
      procedures: 'Proceduri', 
      header_all_locations: 'Toate Locatiile',
      header_all_devices: 'Toate Nebulizatoarele:',
      mnu_settings: 'Setari', 
      mnu_download_pdf: 'Descarca PDF', 
      mnu_report_preview: 'Previzualizare', 
      mnu_inapoi: 'Inapoi', 
      tab_locationName: 'Locatie',
      tab_date: 'Data/Ora Finalizare',
      mnu_report:'Raport',
      card_total_vol: 'Volum Total',
      card_this_month: 'Volum Luna Curenta', 
      card_last_month: 'Volum Luna Trecuta', 
      card_two_months_ago: 'Volum Ultimele 2 Doua Luni', 


      
      mnu_locatii: 'Locatii',
      mnu_setari: 'Setari', 
      mnu_logout: 'Logout',

     select_page_of_users: 'Selecteaza Numarul de Randuri',
      no_data_matching_the_filter: 'Nu Sunt Date pt. Acest Filtru', 
      choose_language: 'Alege Limba',
      copy_right: '© Drepturi de Autor', 
      login_title: 'Intra in Contul Tau',

      // Column labels with the 'tab_' prefix
      tab_val_yes: 'Da', //Da pentru wasSuccesful  
      tab_val_no: 'Nu', //Nu pentru wasSuccesful  
      filter_valoare_noua:'Valoare Noua...', 
      filter_click_for_filter: 'Introdu Valoarea pt. Filtrare si apasa Enter', 
      tab_wasSuccesfull: 'Procedura Corecta',
      tab_mId: 'ID Nebulizator',
      tab_tempEnd: 'Temperatura Finală', 
      tab_machineTotalVolume: 'Volum Total Nebulizator',
      tab_pm03End: 'PM 0.3 Final',
      tab_runVolume: 'Volum Procedura',
      tab_machineSerialNumber: 'Număr Serial Nebulizator',
      tab_hasSensors: 'Are Senzori',
      tab_userDetailsUserName: 'Nume Operator', 
      tab_pm10End: 'PM 10 Final',
      tab_tempStart: 'Temperatura Inițială', 
      tab_userDetailsUserArea: 'Zona Utilizatorului',
      tab_tvocEnd: 'TVOC Final',
      tab_pm10Start: 'PM 10 Inițial',
      tab_dewPoinStart: 'Punct de Rouă Inițial', 
      tab_substanceIdx: 'Indice Substanță', 
      tab_mTime: 'Timp Nebulizator', 
      tab_machineOwnerName: 'Proprietar Nebulizator', 
      tab_roomNumber: 'Număr Incapere',
      tab_solutionName: 'Nume Soluție', 
      tab_roomDetailsRoomName: 'Denumire Incapere',
      tab_tvocStart: 'TVOC Inițial', 
      tab_pm25Start: 'PM 2.5 Inițial',
      tab_roomName: 'Denumire incapere', 
      tab_roomDetailsRoomArea: 'Zonă Incapere', 
      tab_pm25End: 'PM 2.5 Final',
      tab_humidEnd: 'Umiditate Finală', 
      tab_startTime: 'Timp Start', 
      tab_userDetailsUserAuthTime: 'Timp Autorizare Utilizator', 
      tab_endTime: 'Timp Final', 
      tab_humidStart: 'Umiditate Inițială', 
      tab_pm03Start: 'PM 0.3 Inițial', 
      tab_dewPoinEnd: 'Punct de Rouă Final', 
      // tab_wasSuccesful: 'A Fost Un Succes', 
      tab_co2Start: 'CO2 Inițial', 
      tab_roomDetailsRoomVolume: 'Volum Incapere', 
      tab_co2End: 'CO2 Final' 
    },
    de: {
      rep_report: 'Raport',
      procedures: 'Anwendungen',
      header_all_locations: 'Alle Raeume :',
      header_all_devices: 'Alle Geraete :',
      mnu_settings: 'Einstellungen ',
      mnu_download_pdf: ' PDF Herunterladen',
      mnu_report_preview: 'Vorschau',
      mnu_inapoi: 'Zurueck',
      tab_locationName: 'Raum ',
      tab_date: 'Datum',
      mnu_report:'Raport',
      card_total_vol:'Total Volumen ',
      card_this_month:'Volumen Aktueller Monat',
      card_last_month:'Volumen Vohrigen Monat',
      card_two_months_ago:'Volumen Vor 2 Monaten',
      mnu_locatii: 'Raeume',
      mnu_setari: 'Einstellungen',
      mnu_logout: 'Ausloggen',
      select_page_of_users:'Bitte Zeilen Auswaehlen ',
      no_data_matching_the_filter: 'Keine Daten Verfuegbar',
      choose_language: "Bitte Sprache Waehlen",
      copy_right: "©  Urheberrecht",
      login_title: "Eingang zu Deinem Konto",
      tab_val_yes: 'Ja', //Da pentru wasSuccesful
      tab_val_no: 'Nein', //Nu pentru wasSuccesful
      filter_valoare_noua:'Neuer Wert ...',
      filter_click_for_filter: 'Bitte Wert Eingeben und Enter Drucken',
      tab_wasSuccesfull: 'Erfolgreich ',
      tab_mId: 'ID - Geraet',
      tab_tempEnd: 'Endtemperatur ',
      tab_machineTotalVolume: 'Gesamtvolumen fuer Geraet ',
      tab_pm03End: 'PM 0.3 Final',
      tab_runVolume: 'Gesamtvolumen',
      tab_machineSerialNumber: 'Seriennummer des Geraets',
      tab_hasSensors: 'Sensoren Vorhanden',
      tab_userDetailsUserName: 'Name des Anwenders',
      tab_pm10End: 'PM 10 Final',
      tab_tempStart: 'Ausgangstemperatur',
      tab_userDetailsUserArea: 'Anwenderbereich',
      tab_tvocEnd: 'TVOC Final',
      tab_pm10Start: 'PM 10 Angang',
      tab_dewPoinStart: 'Anfaenglicher Taupunkt',
      tab_substanceIdx: 'Werte des Mittels ',
      tab_mTime: 'Laufzeit Geraet',
      tab_machineOwnerName: 'Inhaber des Geraets',
      tab_roomNumber: 'Raumnummer',
      tab_solutionName: 'Namen ds Mittels ',
      tab_roomDetailsRoomName: 'Raumbezeichnung',
      tab_tvocStart: 'TVOC Ausgangswert',
      tab_pm25Start: 'PM 2.5 Anfang',
      tab_roomName: 'Name des Raumes',
      tab_roomDetailsRoomArea: 'Bereich des Zimmers',
      tab_pm25End: 'PM 2.5 Ende ',
      tab_humidEnd: 'Luftfeuchtigkeit am Ende der Prozedur ',
      tab_startTime: 'Startzeit',
      tab_userDetailsUserAuthTime: 'Dauer der Authentifizierung ',
      tab_endTime: 'Gesamtlaufzeit',
      tab_humidStart: 'Ausgaengige Luftfeuchtigkeit',
      tab_pm03Start: 'PM 0.3 Anfang',
      tab_dewPoinEnd: 'Tauzeitam Ende der Prozedur',
      // tab_wasSuccesful: 'Erfolgreich',
      tab_co2Start: 'CO2 Anfang',
      tab_roomDetailsRoomVolume: 'Raumvolumen',
      tab_co2End: 'CO2 Ende '
    }
  };
  